module.exports = __webpack_public_path__ + "static/media/done-green.23aca07b.svg";